import Checkbox from '@/components/Common/Checkbox';
import * as S from './styles';
import { ActionButton } from '@/components/Common/Dialog';
import { mapState } from 'vuex';
import { getIcon } from '../utils';

export default {
    name: 'SecondPanelContent',
    props: {
        widgets: {
            type: Array,
            default: () => [],
        },
        linkedWidgetIds: {
            type: Array,
            default: () => [],
        },
        handleUpdateLinkedWidgetIds: {
            type: Function,
            default: () => {},
        },
        handleCancel: {
            type: Function,
            default: () => {},
        },
        handleSubmit: {
            type: Function,
            default: () => {},
        },
    },
    computed: {
        ...mapState('newDashboard', ['currentWidgetTitlesById']),
        widgetIds() {
            return this.widgets.map((widget) => widget.id);
        },
        isAllSelected() {
            const widgetIdsSet = new Set(this.widgetIds);
            const linkedWidgetIdsSet = new Set(this.linkedWidgetIds);

            return (
                widgetIdsSet.size === linkedWidgetIdsSet.size &&
                widgetIdsSet.size > 0 &&
                [...widgetIdsSet].every((id) => linkedWidgetIdsSet.has(id))
            );
        },
    },
    methods: {
        handleToggleSelectAll(selected) {
            if (selected) {
                this.handleUpdateLinkedWidgetIds(this.widgetIds);
            } else {
                this.handleUpdateLinkedWidgetIds([]);
            }
        },

        getIsWidgetSelected(widgetId) {
            return this.linkedWidgetIds.includes(widgetId);
        },
        handleToggleSelectWidget(widgetId) {
            const isSelected = this.getIsWidgetSelected(widgetId);
            if (isSelected) {
                this.handleUpdateLinkedWidgetIds(
                    this.linkedWidgetIds.filter((id) => id !== widgetId)
                );
            } else {
                this.handleUpdateLinkedWidgetIds([
                    ...this.linkedWidgetIds,
                    widgetId,
                ]);
            }
        },
        getWidgetTitle(widgetId) {
            return this.currentWidgetTitlesById?.[widgetId];
        },
    },
    render() {
        const {
            handleCancel,
            handleSubmit,
            widgets,
            isAllSelected,
            handleToggleSelectAll,
            handleToggleSelectWidget,
            getIsWidgetSelected,
            getWidgetTitle,
        } = this;

        return (
            <S.Wrapper>
                <S.Desc>
                    {this.$t('NEW_DASHBOARD.linked_widgets_panel.desc')}
                </S.Desc>

                <S.ListSelectHeader>
                    <Checkbox
                        value={isAllSelected}
                        onInput={(value) => {
                            handleToggleSelectAll(value);
                        }}
                    />
                    <S.LabelFor
                        onClick={() => handleToggleSelectAll(!isAllSelected)}
                    >
                        {this.$t('COMMON.select_all')}
                    </S.LabelFor>
                </S.ListSelectHeader>
                <S.ListSelectWrapper>
                    <S.ListSelectContent>
                        {widgets.map((widget) => {
                            const Icon = getIcon(widget);
                            const isSelected = getIsWidgetSelected(widget.id);
                            const title = getWidgetTitle(widget.id);

                            return (
                                <S.ListSelectItem
                                    key={widget.id}
                                    isSelected={isSelected}
                                    onClick={() => {
                                        handleToggleSelectWidget(widget.id);
                                    }}
                                >
                                    <Checkbox value={isSelected} />
                                    {Icon && (
                                        <Icon
                                            v-view-box
                                            width="16"
                                            height="16"
                                            style={{ flexShrink: 0 }}
                                            fill="#2A333D"
                                        />
                                    )}
                                    <S.LabelFor class="adriel-ellipsis">
                                        {title}
                                    </S.LabelFor>
                                </S.ListSelectItem>
                            );
                        })}
                    </S.ListSelectContent>
                </S.ListSelectWrapper>

                <S.CTAWrapper>
                    <S.CancelActionButton onClick={handleCancel}>
                        {this.$t('COMMON.cancel')}
                    </S.CancelActionButton>
                    <ActionButton onClick={handleSubmit}>
                        {this.$t('COMMON.apply')}
                    </ActionButton>
                </S.CTAWrapper>
            </S.Wrapper>
        );
    },
};
